export const onInitialClientRender = () => {
  const IS_ACTIVE = {
    TALK_TO: false,
    HOTJAR: true,
    FB_PIXEL: true,
  };

  if (process.env.NODE_ENV === "production") {
    if (IS_ACTIVE.TALK_TO) {
      // Adicionando o script do Tawk.to
      const tawkScript = document.createElement("script");
      tawkScript.type = "text/javascript";
      tawkScript.async = true;
      tawkScript.src =
        "https://embed.tawk.to/677f088149e2fd8dfe0487c9/1ih43if0b";
      tawkScript.charset = "UTF-8";
      tawkScript.setAttribute("crossorigin", "*");

      const firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(tawkScript, firstScript);

      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();

      console.log("Talk.to scripts carregados.");
    }

    if (IS_ACTIVE.HOTJAR) {
      // Adicionando o script do Hotjar
      const hotjarScript = document.createElement("script");
      hotjarScript.type = "text/javascript";
      hotjarScript.async = true;
      hotjarScript.src = "https://static.hj.contentsquare.net/c/csq-5266085.js";

      const headElement = document.getElementsByTagName("head")[0];
      headElement.appendChild(hotjarScript);

      window.hj =
        window.hj ||
        function () {
          (window.hj.q = window.hj.q || []).push(arguments);
        };
      window._hjSettings = { hjid: 5266085 };

      console.log("Hotjar scripts carregados.");
    }

    if (IS_ACTIVE.FB_PIXEL) {
      // Adicionando o script do Facebook Pixel
      const facebookPixelScript = document.createElement("script");
      facebookPixelScript.type = "text/javascript";
      facebookPixelScript.async = true;
      facebookPixelScript.src =
        "https://connect.facebook.net/en_US/fbevents.js";

      const headElementFb = document.getElementsByTagName("head")[0];
      headElementFb.appendChild(facebookPixelScript);

      // Inicializando o Facebook Pixel
      window.fbq =
        window.fbq ||
        function () {
          window.fbq.callMethod
            ? window.fbq.callMethod.apply(window.fbq, arguments)
            : window.fbq.queue.push(arguments);
        };
      if (!window._fbq) window._fbq = window.fbq;
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = "2.0";
      window.fbq.queue = [];

      window.fbq("init", "1382145323116766");
      window.fbq("track", "PageView");

      console.log("FB Pixel scripts carregados.");
    }
  } else {
    console.log("Ambiente de desenvolvimento: scripts não carregados.");
  }
};
